export const removeEmptyValues = data =>
  Object.fromEntries(
    Object.entries(data).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
  );

export const getRouteExtraContext = () => {
  if (typeof window === 'undefined') return {};

  const [root, first, second, third, fourth] = window.location.pathname.split('/').filter(Boolean);
  const searchParams = new URLSearchParams(window.location.search);
  const tab = searchParams.get('tab') || 'extraction';

  if (root === 'data-extraction') {
    return removeEmptyValues({
      workflow_id: first,
      period_id: second,
      file_id: searchParams.get('fileId'),
      sheet_id: searchParams.get('sheetId'),
      extract_id: searchParams.get('extractId'),
      category: searchParams.get('category'),
      table_name:
        tab === 'transformation' ? searchParams.get('extractedTransformationTable') : undefined
    });
  }

  if (root === 'project' && first === 'quaters') {
    return removeEmptyValues({ workflow_id: second, period_id: third });
  }

  if (root === 'project' && first === 'consolidated') {
    return removeEmptyValues({ workflow_id: second });
  }

  if (root === 'project' && first) {
    return removeEmptyValues({ workflow_id: first });
  }

  if (root === 'output-tables' || root === 'output') {
    return removeEmptyValues({ workflow_id: first, period_id: second });
  }

  if (root === 'report') {
    return removeEmptyValues({
      report_type: first,
      reporting_member_state: second,
      workflow_id: third,
      period_id: fourth
    });
  }

  return {};
};
